import { auth as authAdmin } from "@/middlewares/admin";

export default {
  path: "card-builder",
  name: "EdicAdminFacilityCardBuilderManage",
  component: () =>
    import(
      /* webpackChunkName: "edic-admin-facility-management-card-builder-layout-view" */ "@/views/EdicAdmin/Facilities/Manage/CardBuilder/Layout"
    ),
  redirect: { name: "EdicAdminFacilityCardBuilder" },
  children: [
    {
      path: "", // /admin/plan
      name: "EdicAdminFacilityCardBuilder",
      component: () =>
        import(
          /* webpackChunkName: "edic-admin-facility-management-card-builder" */ "@/views/EdicAdmin/Facilities/Manage/CardBuilder/CardBuilder"
        ),
      meta: {
        middleware: [authAdmin],
      },
    },
  ],
};
